import { z } from "zod";

/**
 * Codes d'erreur de l'API. Ils font partie du contrat, au même titre que la
 * forme des réponses : c'est sur eux, et jamais sur `message`, qu'un client
 * s'appuie pour réagir ou pour afficher un texte traduit.
 *
 * `message` reste en français côté serveur — c'est un texte de diagnostic, pas
 * une chaîne d'interface.
 */
export const API_ERROR_CODES = [
  "invalid_value",
  "spot_not_found",
  "spot_already_declared_nearby",
  "contribution_quota_exceeded",
  "location_taken_down",
  "not_the_author",
  "takedown_quota_exceeded",
  "place_search_unavailable",
  "not_found",
  "internal_error",
] as const;

export type ApiErrorCode = (typeof API_ERROR_CODES)[number];

export const isApiErrorCode = (value: unknown): value is ApiErrorCode =>
  typeof value === "string" && (API_ERROR_CODES as readonly string[]).includes(value);

/**
 * Enveloppe d'erreur unique de l'API. `details` transporte le contexte utile au
 * client, par exemple l'identifiant de la pastille déjà déclarée.
 */
export const apiErrorSchema = z.object({
  error: z.object({
    code: z.string(),
    message: z.string(),
    details: z.record(z.string(), z.unknown()).optional(),
  }),
});

export type ApiError = z.infer<typeof apiErrorSchema>;
